<template>
  <div id="app">
    <NavBar />
    
    <main class="main-content">
      <router-view v-slot="{ Component }">
        <transition name="fade" mode="out-in">
          <component :is="Component" />
        </transition>
      </router-view>
    </main>

    <FooterComponent />
  </div>
</template>

<script>
import NavBar from './components/NavBar.vue';
import FooterComponent from './components/FooterComponent.vue';

export default {
  components: {
    NavBar,
    FooterComponent
  }
}
</script>

<style>
#app {
  font-family: 'Noto Sans SC', 'Segoe UI', system-ui, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.main-content {
  margin-top: 80px; /* 匹配导航栏高度 */
  flex: 1;
  min-height: calc(100vh - 160px); /* 增加页脚空间 */
}

/* 移除原有nav相关样式 */
/* 新增响应式调整 */
@media (max-width: 768px) {
  .main-content {
    margin-top: 60px;
  }
}

/* 添加页面切换动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
